module.exports = __webpack_public_path__ + "img/collapse-menu.0ac0e125.svg";